export default __webpack_public_path__ + "static/media/player-team-level.a547d870.svg";